export default __webpack_public_path__ + "63a80c5.png";